var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    viewBox: "0 0 37 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91085 25.0366C2.52156 24.5812 1.58607 23.6705 1.08425 22.2936C-0.139315 18.9296 -0.500185 4.8601 1.85402 2.08771C2.65941 1.14138 3.69558 0.586902 4.92999 0.453704C11.2755 -0.229327 30.8882 -0.131751 33.1495 0.682929C34.4738 1.15842 35.4123 2.02576 35.925 3.35155C37.2632 6.82865 37.3097 19.4779 35.7484 22.828C35.3256 23.7356 34.6364 24.3768 33.7582 24.8368C31.3916 26.079 7.02554 26.0635 3.9124 25.0366H3.91085ZM13.9906 18.4417C17.8069 16.4623 21.5891 14.5015 25.4193 12.5144C21.5829 10.5133 17.8007 8.5401 13.9906 6.55141V18.4417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.827be2b7067bcd4bb587611a7d9d9afd.svg";
export { ForwardRef as ReactComponent };